import { TWindowCoords, TWindowMoveDelta, TWindowResizeDirection } from './types';

// Направления, при которых react-rnd двигает окно, а не только меняет его размер:
// тянем за верх или за левый край — противоположный край остаётся на месте.
const POSITION_SHIFTING_DIRECTIONS: TWindowResizeDirection[] = [
  'top',
  'left',
  'topLeft',
  'bottomLeft',
  'topRight',
];

/**
 * Координаты окна после завершённого ресайза.
 *
 * Нельзя просто взять пятый аргумент `onResizeStop` (`resizingPosition`): он содержит
 * `offsetFromParent`, а проп `position`, который мы ему скармливаем обратно, — нет.
 * Замер вживую: `offsetFromParent.left = -356`, и окно уезжало на эту величину после
 * каждого ресайза за левый край. Поэтому повторяем ту же арифметику, что react-rnd
 * делает внутри `onResize`, но в системе координат пропа `position`.
 */
export function getCoordsAfterResize(
  coords: TWindowCoords,
  delta: TWindowMoveDelta,
  direction: TWindowResizeDirection,
): TWindowCoords {
  if (!POSITION_SHIFTING_DIRECTIONS.includes(direction)) {
    return coords;
  }

  if (direction === 'bottomLeft') {
    return { x: coords.x - delta.width, y: coords.y };
  }

  if (direction === 'topRight') {
    return { x: coords.x, y: coords.y - delta.height };
  }

  return { x: coords.x - delta.width, y: coords.y - delta.height };
}
